import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { QtySelectComponentDef } from '@df/ui/form/qty-select.component.def';

@Component({
    selector: 'basket-item-qty',
    templateUrl: 'basket-item-qty.html',
    styleUrls: ['basket-item-qty.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BasketItemQtyComponent extends QtySelectComponentDef {}
